/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter detections by asset type involved
 * @export
 */
export const ControlAssetType1 = {
    User: 'USER',
    Process: 'PROCESS',
    UserAgent: 'USER_AGENT',
    File: 'FILE',
    Endpoint: 'ENDPOINT',
    Location: 'LOCATION',
    Ip: 'IP',
    Domain: 'DOMAIN'
} as const;
export type ControlAssetType1 = typeof ControlAssetType1[keyof typeof ControlAssetType1];


export function ControlAssetType1FromJSON(json: any): ControlAssetType1 {
    return ControlAssetType1FromJSONTyped(json, false);
}

export function ControlAssetType1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAssetType1 {
    return json as ControlAssetType1;
}

export function ControlAssetType1ToJSON(value?: ControlAssetType1 | null): any {
    return value as any;
}

